import script from "./Thread.vue?vue&type=script&setup=true&lang=ts"
export * from "./Thread.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy});
